/* eslint-disable no-useless-escape */
import _ from "lodash";
import $ from "jquery";
import { BroadcastChannel } from 'broadcast-channel';
import Moment from "moment";
import momentTimezone from 'moment-timezone';
import { joyRideGuestSteps, joyRideGuestStepsPremium, joyRideSteps, joyRideStepsManager, joyRideStepsManagerPremium, joyRideStepsPremium } from "./joyRideJsonScript";
import { extendMoment } from 'moment-range';
import CryptoJS from "crypto-js";
import { getAssignBrokerCourse, getAssignCourse, getCheckListInsert } from "../redux/courses/actions";
import CONFIG from "./config";

const moment = extendMoment(Moment);
export const LOGIN_CHANNEL = new BroadcastChannel('login');

export const emailValidation = (emailStr) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!emailStr || regex.test(emailStr) === false) {
        return false;
    }
    return true;
}

export const cnfPwdValidation = (pass, cnfPwd) => {
    if (pass === null || pass === undefined || pass === '' || pass !== cnfPwd) {
        return false
    }
    return true;
}

export const passLimitValidation = (pass) => {
    if (pass === null || pass === undefined || pass.length < 6) {
        return false
    }
    return true;
}

export const passCharValidation = (password) => {
    var regularExpression = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()-_+={}[]|\/:;"'<>,.?])[a-zA-Z0-9~`!@#$%^&*()-_+={}[]|\/:;"'<>,.?]{6,}$/;
    return regularExpression.test(password)
}

export const logoutClearSession = () => {
    // localStorage.removeItem(SessionKeys.API_TOKEN);
    localStorage.removeItem(SessionKeys.BROKER_ID);
    localStorage.removeItem(SessionKeys.IS_PREMIUM);
    localStorage.removeItem(SessionKeys.EMAIL_SESSION);
    localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
    localStorage.removeItem(SessionKeys.HOSTINST_ID);
    localStorage.removeItem(SessionKeys.NOTI_SHOW);
    localStorage.removeItem(SessionKeys.SESSION_ID);
    // localStorage.setItem(SessionKeys.REMIND_ME_LATER,false)
    localStorage.removeItem('persist:root')
}


export const SessionKeys = {
    EMAIL: "EMAIL",
    EMAIL_SESSION: "EMAIL_SESSION",
    PASS: "PASSWORD",
    API_TOKEN: "API_TOKEN",
    API_TOKEN_BROKER: "API_TOKEN_BROKER",
    IS_REMEMBERED: "IS_REMEMBERED",
    IS_PREMIUM: "IS_PREMIUM",
    REMIND_ME_LATER: "REMIND_ME_LATER",
    USERNAME: "USERNAME",
    IFRAME_USERNAME: "IFRAME_USERNAME",
    BROKER_ID: "BROKER_ID",
    BROKER_NAME: "BROKER_NAME",
    HOSTINST_ID: "HOSTINST_ID",
    IS_AGGREED: "IS_AGGREED",
    USER_ID: "USER_ID",
    NOTI_SHOW: "NOTI_SHOW",
    IS_TOUR: "IS_TOUR",
    COMPLETE_TOUR: "COMPLETE_TOUR",
    FIRST_NAME: "FIRST_NAME",
    SSO_ENABLED: "SSO_ENABLED",
    LOCATION_PATH_REDIRECT: "LOCATION_PATH_REDIRECT",
    SESSION_ID: "cart_session_id",
    LOGIN_COMPANY: "login_company",
    DYNAMIC_CONTENT: "dynamic_content",

    //menu show config
    SHOW_ROLEPLAY: "SHOW_ROLEPLAY",
    SHOW_POINTS: "SHOW_POINTS",
    SHOW_DISCUSS_TAB: "SHOW_DISCUSS_TAB",
    SHOW_MY_WALL: "SHOW_MY_WALL",
    SHOW_OFFICE_NAME: "SHOW_OFFICE_NAME",
    SHOW_LEADERBOARD: "SHOW_LEADERBOARD",
    SHOW_MENTER_COACH: "SHOW_MENTER_COACH",

    //IMPERSONATE
    IS_IMPERSONATED: "IS_IMPERSONATED",
    LOGGED_IN_USER_TOKEN: "LOGGED_IN_USER_TOKEN",
    LOGGED_IN_USER_ID: "LOGGED_IN_USER_ID",
    FLASH: "FLASH",
    NEW_AI_ROLEPLAY_TOKEN: "NEW_AI_ROLEPLAY_TOKEN"
};

export const clickStreamUser = (eventName, eventObj) => {
    let evtObj = {
        user_id: localStorage.getItem(SessionKeys.USER_ID),
        first_name: localStorage.getItem(SessionKeys.FIRST_NAME),
        last_name: "",
        browser: getBrowserName(),
        os: detectOS(),
        timestamp: Date.now(),
        pageName: eventName,
        eventType: eventName, // Page View, API Call, API Call REsponse, Click
        name: "b2c-react",
        eventObj
    }
    window.captureMyEvents(eventName, evtObj);
}

const detectOS = () => {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

const getBrowserName = () => {
    let browserInfo = navigator.userAgent;
    let browser;
    if (browserInfo.includes('Opera') || browserInfo.includes('Opr')) {
        browser = 'Opera';
    } else if (browserInfo.includes('Edg')) {
        browser = 'Edge';
    } else if (browserInfo.includes('Chrome')) {
        browser = 'Chrome';
    } else if (browserInfo.includes('Safari')) {
        browser = 'Safari';
    } else if (browserInfo.includes('Firefox')) {
        browser = 'Firefox'
    } else {
        browser = 'unknown'
    }
    return browser;
}


export const checkCall = () => {
    // console.log('checkCall')
}

export const setIconForReport = (status) => {
    switch (status) {
        case 'in-progress':
            return "/images/inprogress.svg"
        case 'not-started':
        case 'over-due':
            return "/images/not-started.svg"
        default:
            return "/images/check-report.svg"
    }
}

export const convertTimeFormat = (duration, isSecond = false) => {
    // console.log(isSecond ? duration : "")
    if (isSecond) {
        if (duration >= 86400) {
            return convertTimeInDaysHoursAndMin(duration)
        } else {
            let secondHand = duration % 60;
            duration = parseInt(duration / 60);
            if (secondHand) {
                // return `${duration} ${duration > 1 ? 'Mins' : 'Min'} ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                if (duration > 60) {
                    let hours = Math.floor(duration / 60);
                    let minutes = duration % 60;
                    hours = hours >= 10 ? hours : `0${hours}`;
                    minutes = minutes >= 10 ? minutes : `0${minutes}`;
                    secondHand = secondHand >= 10 ? secondHand : `0${secondHand}`;
                    if (_.toNumber(minutes) === 0) {
                        return `${hours} ${hours > 1 ? 'Hours' : 'Hour'} ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                    } else {
                        return `${hours} ${hours > 1 ? 'Hours' : 'Hour'} ${minutes} ${minutes > 1 ? 'Mins' : 'Min'} ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                    }
                } else if (duration < 60) {
                    let minutes = duration >= 10 ? duration : `0${duration}`;
                    secondHand = secondHand >= 10 ? secondHand : `0${secondHand}`;
                    if (_.toNumber(minutes) === 0) {
                        return `${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                    } else {
                        return `${minutes} ${minutes > 1 ? 'Mins' : 'Min'} ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                    }
                } else if (duration === 60) {
                    return `01 Hour ${secondHand} ${secondHand > 1 ? 'Secs' : 'Sec'}`
                }
            } else {
                return convertTimeInHourAndMin(duration)
            }
        }
    } else {
        return convertTimeInHourAndMin(duration)
    }
}

export const formatSecondsHand = (duration) => {
    const secondsHand = duration >= 10 ? duration : `0${duration}`
    return `${secondsHand} Sec${duration > 1 ? "s" : ""}`;
}


export const convertTimeInHourAndMin = (duration) => {
    if (duration > 60) {
        let hours = Math.floor(duration / 60);
        let minutes = duration % 60;
        hours = hours >= 10 ? hours : `0${hours}`;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        if (_.toNumber(minutes) === 0) {
            return `${hours} ${hours > 1 ? 'Hours' : 'Hour'}`
        } else {
            return `${hours} ${hours > 1 ? 'Hours' : 'Hour'} ${minutes} ${minutes > 1 ? 'Mins' : 'Min'}`
        }
    } else if (duration === 0) {
        return ''
    } else if (duration < 60) {
        let minutes = duration >= 10 ? duration : `0${duration}`;
        return `${minutes} ${minutes > 1 ? 'Mins' : 'Min'}`
    } else if (duration == 60) {
        return '01 Hour'
    }
}

export const convertTimeInDaysHoursAndMin = (duration) => {
    if (duration > 86400) {
        let day = Math.floor(duration / 3600) / 24
        let remainingDuration = duration % 24;
        let hoursMin = ''
        if (remainingDuration) {
            hoursMin = convertTimeFormat(remainingDuration, true)
        }
        return `${day} ${day > 1 ? 'Day' : 'Days'} ${hoursMin}`
    } else {
        return "1 Day"
    }
}

const htmlParse = (description) => {
    const parser = new DOMParser();

    // Parse the HTML string
    const doc = parser.parseFromString(description, 'text/html');

    // Extract text content
    const text = doc.body.textContent;
    return text;
}


export const truncatedDescription = (description, maxLength) => {
    description = htmlParse(description);
    const truncatedText = description.length > maxLength ? `${description.substring(0, maxLength).replace(/\s+\S*$/, '')} ...` : description;
    return truncatedText;
}

export const formatDateTime = (dateString) => {
    const date = momentTimezone.tz(dateString, 'America/New_York');
    const formattedTime = date.format('h:mma');
    const formattedDate = date.format('ddd, Do MMM YYYY');
    const timezoneShort = date.format('z');
    return `Begins ${formattedTime} ${timezoneShort}, ${formattedDate}`;
}


export const formatStartDateTime = (dateString, timeString, timezoneAbbr) => {

    const combinedDateTime = `${dateString.replaceAll('-', '/')} ${timeString}`;
    const date = moment.utc(combinedDateTime).tz(timezoneAbbr)
    const formattedTime = date?.format('h:mma');
    const formattedDate = date?.format('ddd, Do MMM YYYY');
    const timezoneShort = date?.format('z');

    return `Begins ${formattedTime} ${timezoneShort}, ${formattedDate}`;
};



export const isSessionWithinOneHour = (startDateString, startTimeString, endDateString, endTimeString, timezoneAbbr) => {
    const startCombinedDateTime = `${startDateString.replaceAll('-', '/')} ${startTimeString}`;
    const endCombinedDateTime = `${endDateString.replaceAll('-', '/')} ${endTimeString}`;

    const startDateTime = moment.utc(startCombinedDateTime).tz(timezoneAbbr);
    const endDateTime = moment.utc(endCombinedDateTime).tz(timezoneAbbr);

    // Get the current datetime in the specified timezone
    const currentDateTime = moment.utc().tz(timezoneAbbr);
    // Check if the current datetime is within the session start and end times
    const isWithinSession = currentDateTime?.isBetween(startDateTime, endDateTime, null, '[]');
    // Calculate the difference in minutes between the session start datetime and the current datetime
    const timeDifferenceInMinutes = startDateTime?.diff(currentDateTime, 'minutes');
    // Check if the session is commencing within 1 hour (60 minutes) from now and is currently active
    return isWithinSession || (timeDifferenceInMinutes <= 60 && timeDifferenceInMinutes >= 0);
};

export const isSessionWithinOneHourForLive = (startDateString, startTimeString, endDateString, endTimeString, timezoneAbbr) => {
    const startCombinedDateTime = `${startDateString.replaceAll('-', '/')} ${startTimeString}`;
    const endCombinedDateTime = `${endDateString.replaceAll('-', '/')} ${endTimeString}`;

    const startDateTime = moment.utc(startCombinedDateTime).tz(timezoneAbbr);
    const endDateTime = moment.utc(endCombinedDateTime).tz(timezoneAbbr);

    // Get the current datetime in the specified timezone
    const currentDateTime = moment.utc().tz(timezoneAbbr);
    // Check if the current datetime is within the session start and end times
    const isWithinSession = currentDateTime?.isBetween(startDateTime, endDateTime, null, '[]');
    // Calculate the difference in minutes between the session start datetime and the current datetime
    const timeDifferenceInMinutes = startDateTime?.diff(currentDateTime, 'minutes');
    // Check if the session is commencing within 1 hour (60 minutes) from now and is currently active
    return isWithinSession ? 1 : (timeDifferenceInMinutes <= 60 && timeDifferenceInMinutes >= 0) ? 2 : 3;
};




export const findUpcomingSession = (sessions) => {
    const currentDate = new Date();

    const upcomingSessions = sessions.filter(session => {

        const startDate = new Date(`${session.date_time[0].start_date} ${session.date_time[0].start_time}`);

        // Compare with the current date and time
        return startDate > currentDate;
    });

    // Sort upcoming sessions by start date and time
    upcomingSessions.sort((a, b) => {
        const startDateA = new Date(`${a.date_time[0].start_date} ${a.date_time[0].start_time}`);
        const startDateB = new Date(`${b.date_time[0].start_date} ${b.date_time[0].start_time}`);
        return startDateA - startDateB;
    });

    // Return the first upcoming session
    return upcomingSessions.length > 0 ? upcomingSessions : null;
}

export const formatEndDateTime = (dateString, timeString, timezoneAbbr) => {
    const combinedDateTime = `${dateString.replaceAll('-', '/')} ${timeString}`;
    // const dateCombinedString = new Date(combinedDateTime);
    // const date = momentTimezone.tz(dateCombinedString, timezoneAbbr); 
    const date = moment.utc(combinedDateTime).tz(timezoneAbbr)
    const formattedTime = date?.format('h:mma');
    const formattedDate = date?.format('ddd, Do MMM YYYY');
    const timezoneShort = date?.format('z');
    // Return the formatted string
    return `Ends ${formattedTime} ${timezoneShort}, ${formattedDate}`;
};

export const convertHoursToMins = (duration) => {
    const convertArray = _.toString(duration).includes(':') ? duration.split(":") : [duration, 0]
    const hoursMinutes = _.toNumber(convertArray[0]) * 60
    const minutes = _.toNumber(convertArray[1])
    const totalMinutes = hoursMinutes + minutes
    return totalMinutes;
}

export const convertSecondsToMins = (duration) => {
    // console.log('SECONDS', duration)
    const totalMinutes = Math.floor(_.toNumber(duration) / 60);
    // console.log('SECONDS', totalMinutes)
    return totalMinutes;
}

export const convertMinutesToHoursAndMinutes = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')} Hr ${mins.toString().padStart(2, '0')} Mins`;
}

export const getWordSpeedType = (wpm) => {
    if (wpm >= 1 && wpm <= 120) {
        return 'Slow';
    } else if (wpm > 120 && wpm <= 160) {
        return 'Appropriate';
    } else if (wpm > 160) {
        return 'Faster';
    } else {
        return '';
    }
}

export const timezoneTagName = (abbr) => {
    switch (abbr) {
        case 'PDT':
            return 'PT'
        case 'EDT':
            return 'ET'
        case 'ADT':
            return 'AT'
        case 'MDT':
            return 'MT'
        case 'NDT':
            return 'NT'
        case 'CDT':
            return 'CT'
        default:
            return abbr
    }
}

export const timezoneArea = (offset) => {
    switch (offset) {
        case '-0500':
            return 'America/Chicago' // CST
        case '-0600':
            return 'America/Denver' // MST
        case '-0400':
            return 'America/New_York' // EST
        case '-0700':
            return 'America/Los_Angeles' // PT (480)
        case '-0230':
            return 'America/St_Johns' // NT
        case '-0300':
            return 'America/Blanc-Sablon' // AT
        default:
            return 'America/New_York'
    }
}

export const videoExtensionType = (extension) => {
    switch (extension) {
        case 'm3u8':
            return 'application/x-mpegURL'
        default:
            return 'video/mp4'
    }
}

export const applyTheme = (branding) => {
    $('body').addClass('cus-bro-theme')
    $("html").css(
        "--color-element-1",
        branding.primary_color
    );
    $("html").css(
        "--primary_color",
        branding.primary_color
    );

    $("html").css(
        "--primary_light_color",
        branding.primary_light_color
    );

    $("html").css(
        "--secondary_color",
        branding.secondary_color
    );

    $("html").css(
        "--secondary_light_color",
        branding.secondary_light_color
    );

    $("html").css(
        "--primary_btn_color",
        branding.primary_btn_color
    );

    $("html").css(
        "--primary_btn_light_color",
        branding.primary_btn_light_color
    );

    $("html").css(
        "--progress_color",
        branding.progress_color
    );

    $("html").css(
        "--primary_btn_text_color",
        branding.primary_btn_text_color
    );

    // $("html").css(
    //     "--icon-color",
    //     branding.icon_color
    // );
    // $("html").css(
    //     "--currntweek",
    //     branding.currwk_header_color
    // );
    // $("html").css(
    //     "--past-week",
    //     branding.ptwk_header_color
    // );
    // $("html").css(
    //     "--future-week",
    //     branding.ftwk_header_color
    // );
    // $("html").css(
    //     "--footer-bg-color",
    //     branding.footer_bg_color
    // );
    // $("html").css(
    //     "--footer-text-color",
    //     branding.footer_text_color
    // );

    // if (branding.course_launch_url) {
    //     console.log('COURSE LAUNCH URL', branding.course_launch_url)
    //     $(".cus-bro-theme .video_img").css('background', 'url(' + branding.course_launch_url + ')')
    // }
    return true;
}

export const UserIsLoggedIn = () => {
    LOGIN_CHANNEL.postMessage({ login: true })
}

export const IsLogin = () => {
    LOGIN_CHANNEL.onmessage = (event) => {
        if (event.data && event.data?.login) {
            window.location.reload();
        }
    }
}

export const calculateRolePlayScore = (data) => {
    let point = 0;
    Object.keys(data).forEach((d) => {
        point = point + _.toNumber(data[d])
    })
    return point;
}

export const fixedToDecimal = (value, decimalValue) => {
    return _.toNumber(value).toFixed(decimalValue)
}

export const rolePlayStatus = (type, role = 'participant') => {
    switch (type) {
        case "draft":
        default:
            return (<span className="pfrpending draftrev">Draft</span>)
        case "pending_review":
            return (<span className="pfrpending">Pending Review</span>)
        case "feedback_received":
            return (
                <span className="frdone">Feedback {role === 'participant' ? 'Received' : 'Provided'}</span>
            )
    }
}

export const starRatingCaptions = (rating) => {
    if (rating >= 1 && rating < 2) {
        return "Give it another go!";
    } else if (rating >= 2 && rating < 3) {
        return "You're almost there!";
    } else if (rating >= 3) {
        return "You nailed it!"
    }
}

export const getDateTime = (time, userDetails) => {

    if (time === undefined) {
        return '- -'
    }

    const timezoneOffset = !_.isEmpty(userDetails.timezone) ?
        userDetails.timezone.replace(':', '') : '-0500'
    const area = timezoneArea(timezoneOffset)
    var today = moment.unix(time).tz(area)?.format('MMM DD YYYY h:mm A')
    return today;
}


export const getFormatCourseListFromWoo = (course, isPremiumUser) => {
    // for (let course of courseList) {
    course.is_purchased = course.is_paid;
    course.showBuy = course.is_purchased ? false : true;
    course.is_bundle = false;
    course.is_free = false;
    if (course?.sfdc_product_type?.toLowerCase() === "basic") {
        course.showBuy = false;
        course.is_paid = true;
        course.is_free = true;
    } else if (
        course?.sfdc_product_type?.toLowerCase() === "premium"
    ) {
        if (isPremiumUser) {
            course.showBuy = false;
            course.is_paid = true;
            course.is_free = true;
        } else {
            if (course.product_offer_for_basic) {
                course.sale_price = 0.0;
                course.regular_price = 0.0;
            } else {
                course.sale_price = course.product_basic_price;
                course.regular_price = course.product_market_price;
            }
        }
    } else if (
        course?.sfdc_product_type?.toLowerCase() === "alacarte"
    ) {
        if (isPremiumUser) {
            if (course.product_offer_for_premium) {
                course.sale_price = 0.0;
                course.regular_price = 0.0;
            } else {
                course.sale_price = course.product_premium_price;
            }
        } else {
            if (course.product_offer_for_basic) {
                course.sale_price = 0.0;
                course.regular_price = 0.0;
            } else {
                course.sale_price = course.product_basic_price;
            }
        }
        course.regular_price = course.product_market_price;
    } else if (
        course?.sfdc_product_type?.toLowerCase() === "bundle"
    ) {
        course.is_bundle = true;
        if(course?.course_list) {
            for (let cl of course?.course_list) {
                cl.source = course.source;
                cl.is_free = course.is_free
            }
        }
    }
    if (course?.sfdc_product_type?.toLowerCase() !== "bundle") {
        if (course.durationUnit === "Hours") {
            course.duration = convertHoursToMins(course.duration);
        }
        else if (course.durationUnit === "Seconds") {
            course.duration = convertTimeFormat(course.duration, true);
        }
        // course.duration = convertTimeFormat(
        //     _.toNumber(course.duration)
        // );
        course.durationUnit = "";
    } else {
        // console.log('Duration', course)
        if(course.course_list){
        for (let cl of course.course_list) {
            if (cl.durationUnit === "Hours") {
                cl.duration = convertHoursToMins(cl.duration);
            }
            cl.duration = convertTimeFormat(_.toNumber(cl.duration));
            cl.durationUnit = "";
        }}
    }
    // }
    return course;
}

export const formatLPCoursesList = (learning) => {
    if (learning.coursesList) {
        learning.is_manager_checklist = false;
        learning.newCourseList = []
        for (let [index, course] of learning.coursesList.entries()) {
            let currentCourse = course;
            let nextCourse = learning.coursesList[index + 1];
            if (learning.sequence === 1) {
                console.log('is sequence');
                if (index === 0) {
                    currentCourse.isLock = false;
                }
                currentCourse.isLock = currentCourse.isLock === false ? currentCourse.isLock : true;
                if (currentCourse.crs_progress > 0) {
                    console.log('CURRENT PROGRESS IS MORE THAN ZERO')
                    // currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
                    if (index !== learning.coursesList.length - 1) {
                        console.log("INDEX IS NOT LAST")
                        nextCourse.isLock = (_.toNumber(currentCourse.crs_progress) >= 100 && !currentCourse.isLock) ? false : true;
                        console.log('NEXT COURSE ISLOCK', nextCourse.isLock)
                    }
                }
            } else {
                currentCourse.isLock = currentCourse.isLock ? currentCourse.isLock : false;
            }
            currentCourse.duration = convertTimeFormat(_.toNumber(currentCourse.duration));
            currentCourse.durationUnit = ''
            // console.log("detaiiii", course)
            if (index < learning.coursesList.length - 1) {
                if (!currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present) {
                    nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false
                } else if ((currentCourse?.is_checklist_approved && currentCourse?.is_checklist_present)) {
                    nextCourse.isLock = false
                }

                if (currentCourse.is_checklist_present) {
                    learning.is_manager_checklist = true;
                }
            }
        }
        for (let course of learning.coursesList) {
            course.is_manager_checklist = learning.is_manager_checklist
        }
        // learning.courseList[0].isLock = false;

        for (let course of learning.coursesList) {
            course.is_manager_checklist = learning.is_manager_checklist
            if (course.durationUnit === "Hours") {
                const convertArray = _.toString(course.duration).includes(":")
                    ? course.duration.split(":")
                    : [course.duration, 0];
                const hoursMinutes = _.toNumber(convertArray[0]) * 60;
                const minutes = _.toNumber(convertArray[1]);
                const totalMinutes = hoursMinutes + minutes;
                course.duration = totalMinutes;
            }
            if (_.toNumber(course.duration) > 60) {
                let hours = Math.floor(course.duration / 60);
                let minutes = course.duration % 60;
                hours = hours >= 10 ? hours : `0${hours}`;
                minutes = minutes >= 10 ? minutes : `0${minutes}`;
                // console.log(course.duration, hours, minutes)
                // course.duration = `${hours}:${minutes}`
                course.duration = `${hours} ${hours > 1 ? "Hours" : "Hour"
                    } ${minutes} ${minutes > 1 ? "Mins" : "Min"}`;
                course.durationUnit = "";
            } else if (_.toNumber(course.duration) < 60) {
                // console.log('Minutes')
                course.duration = `${course.duration} ${course.duration > 1 ? "Mins" : "Min"
                    }`;
                course.durationUnit = "";
            } else {
                // console.log('hour')
                course.duration = "1 Hour";
                course.durationUnit = "";
            }
        }
    }
    return learning;
}

export const getStepIndex = (targetIndex, userRole, isPremium, isGuest = false) => {
    console.log("rolesData: ", userRole, isPremium, isGuest)
    let arrName = getJoyRideScript(userRole, isPremium, isGuest)
    for (let [i, record] of arrName.entries()) {
        if (record.target === targetIndex) {
            return i;
        }
    }
}

export const getJoyRideScript = (userRole, isPremium, isGuest = false) => {
    let arrName = isGuest ? joyRideGuestSteps : joyRideSteps
    if (userRole === 'manager') {
        if (isPremium) {
            arrName = joyRideStepsManagerPremium
        } else {
            arrName = joyRideStepsManager
        }
    } else if (isPremium) {
        arrName = isGuest ? joyRideGuestStepsPremium : joyRideStepsPremium
    }
    return arrName;
}

export const showOBLPProgessNaming = (progress) => {
    if (_.toNumber(progress) === 0) {
        return "Not Started";
    } else if (_.toNumber(progress) === 100) {
        return "Completed";
    } else {
        return "In Progress";
    }
};

export const getFrequency = (frequency) => {
    switch (frequency) {
        case 'Monthly':
            return 'month';
        case 'One time':
            return "";
        default:
            return '';
    }
}

export const webViewCallbackHandler = (data) => {
    if (window.callbackHandler !== undefined) {
        window.callbackHandler.postMessage(data);
    }
    if (window.webkit !== undefined) {
        if (window.webkit.messageHandlers.callbackHandler !== undefined) {
            window.webkit.messageHandlers.callbackHandler.postMessage(
                data
            );
        }
    }
}

export const getPriceInfoForEntity = (info) => {
    const {
        isUserPremium, productType, premiumPrice, basicPrice,
        offerPremiumPrice, offerBasicPrice,
        offerEndDate, offerStartDate, source, productIsPaid, inAddToCart
    } = info;

    let isFree = false;
    let isPaid = false;
    let isAddToCart = false;
    let price = 0;

    if (source === 'xsel' || source === 'ecom') {
        if (productType === 'alacarte') {
            isFree = false;
            isPaid = productIsPaid;
            isAddToCart = inAddToCart;
            price = isUserPremium ? premiumPrice : basicPrice;
            if (moment(offerStartDate).isSameOrAfter(moment()) &&
                moment(offerEndDate).isSameOrBefore(moment())) {
                price = isUserPremium ? offerPremiumPrice : offerBasicPrice;
            }
        } else {
            if (!isUserPremium) {
                if (productType === 'basic') {
                    isFree = true;
                } else {
                    isFree = false;
                    isPaid = productIsPaid;
                    isAddToCart = inAddToCart;
                }
            } else {
                isFree = true;
            }
            price = isUserPremium ? premiumPrice : basicPrice;
            if (moment(offerStartDate).isSameOrAfter(moment()) &&
                moment(offerEndDate).isSameOrBefore(moment())) {
                price = isUserPremium ? offerPremiumPrice : offerBasicPrice;
            }
        }
    } else {
        isFree = true;
        isPaid = false;
        isAddToCart = false;
    }

    return {
        isFree,
        isPaid,
        isAddToCart,
        price,
    }
}

export const getProcureInfo = (info) => {
    if (!_.isEmpty(info)) {
        return {
            isFree: info.selling_price === 0 || info.is_purchased,
            isPurchased: info.is_purchased,
            isAddToCart: false,
            isOffer: info.is_offer,
            price: info.selling_price,
            offerPrice: info.offer_price,
            showText: info.enrolled_text,
            textColor: info.enrolled_text_color_code,
            teaserViewed: info.teaser_view,
            teaserAccessed: info.teaser_view_completed,
        }
    }
    return {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: false,
        showText: '',
        textColor: "#DC3872",
        teaserViewed: false,
        teaserAccessed: false,
    }
}

export const FreePaidSubscription = () => {
    return (
        <span className="signup-btn">Free with paid subscriptions</span>
    )
}

export const emptyComp = () => {
    return (<></>)
}

export const ProductCardPriceInfo = (stmt, colorCode) => {
    return (
        <span className="signup-btn offer-price-com" style={{ color: colorCode }}
            dangerouslySetInnerHTML={{ __html: stmt }}
        ></span>
    )
}

export const FreeForYou = () => {
    return (
        <span className="signup-btn">Free for you</span>
    )
}

export const PurchasedOn = (date) => {
    return (
        <span className="price-band">Purchased on {date}</span>
    )
}

export const PriceAt = (price, inCart = false) => {
    return (
        <>
            <span className="signup-btn">Price: ${price}</span>
            {inCart && <span class="pc-datebar">In your cart</span>}
        </>
    )
}



// Function to format the hour and minute
const formatTime = (dateString, timezone) => {
    const date = new Date(dateString * 1000);
    // Use Intl.DateTimeFormat to format the date in EST
    const options = {
        hour: 'numeric', minute: 'numeric',
        timeZone: timezone, // EST is represented by the America/New_York time zone
        hour12: true // Use 12-hour clock
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const estDate = formatter.format(date);
    const dateInNewYork = moment.tz(timezone ? timezone : 'America/New_York');
    const timezoneShort = dateInNewYork.format('z');
    return `${estDate} ${timezoneShort}`;

    // return `${formattedHours}:${formattedMinutes} ${ampm}`;
};





export const PriceForSession = (enrolledText, endTime, userDetails) => {

    return (
        <>
            {enrolledText ? <span className="signup-btn">{enrolledText}</span> : ""}
            <span class="pc-datebar signup-btn" >Live now, ends at {formatTime(endTime, userDetails?.timezoneAbbr)}</span>
        </>
    )
}

export const PriceInfo = (price, time) => {
    return (
        <>
            {price ? <span class="signup-btn">Price: ${price}</span> : <span className="signup-btn">Free for you</span>}
            {/* <span class="signup-btn">Price: ${price}</span> */}
            <span class="pc-datebar">{formatDateTime(time)}</span>
        </>
    )
}
export const SessionPrice = (price) => {
    return (
        <>
            <div class="price-bar">Price: <span> ${price}</span>
            </div>
        </>
    )
}

export const getNumberOfWeeksInMonth = (year, month) => {
    console.log("year, month ", year + ", " + month)
    let startDate = moment([year, month])
    let firstDay = moment(startDate).startOf('month')
    let endDay = moment(startDate).endOf('month')
    let monthRange = moment.range(firstDay, endDay);

    let weeks = []
    for (let mday of monthRange.by('days')) {
        // console.log("mday", mday.week());
        if (weeks.indexOf(mday.week()) === -1) {
            weeks.push(mday.week());
        }
    }

    let calendar = []
    for (let index = 0; index < weeks.length; index++) {
        var weeknumber = weeks[index];


        let firstWeekDay = moment(firstDay).week(weeknumber).day(0);
        if (firstWeekDay.isBefore(firstDay)) {
            firstWeekDay = firstDay;
        }

        let lastWeekDay = moment(endDay).week(weeknumber).day(6);
        if (lastWeekDay.isAfter(endDay)) {
            lastWeekDay = endDay;
        }

        //console.log("\n week number: " + index, firstWeekDay.format("DD-MM-YYYY"), lastWeekDay.format("DD-MM-YYYY"));
        // document.write("<br>week number: " + index + " day: " + firstWeekDay.format("DD-MM-YYYY") + " to " + lastWeekDay.format("DD-MM-YYYY"))
        let weekRange = moment.range(firstWeekDay, lastWeekDay)
        calendar.push(weekRange)
    }

    console.log('weeklength: ', calendar.length)

    return calendar.length;

}


export const isInCurrentMonth = (currentMonth, startMonth, endMonth, date) => {
    // let startMonth = moment().startOf("month").clone().add(currentMonth, "M").startOf("M");
    // let endMonth = startMonth.clone().endOf("M");
    console.log('rangeDates: ', startMonth, endMonth, date)
    let range = moment.range(startMonth, endMonth)
    let date1 = new Date(date);
    console.log('rangeDatesCompare: ', range.contains(date1))
    return range.contains(date);
}


export const isConatainsSymbol = (str) => {
    const regex = /[!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\]/;
    if (regex.test(str)) {
        return true;
    } else {
        return false;
    }

}

export const randomGenerator = (length = 8) => {
    let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

export const subscriptionTrailType = (days) => {
    switch (days) {
        case 7:
            return 'week'
        case 30:
            return 'month'
        case 90:
            return 'quater'
        case 180:
            return 'half year'
        case 360:
            return 'year'
        default:
            return 'month'
    }
}

export const encyptData = (obj) => {
    var key = CryptoJS.enc.Utf8.parse('bbf0c21d0674978d115dfffe91a734a5');     // Use Utf8-Encoder. 
    var iv = CryptoJS.enc.Utf8.parse('15db1af7ed6d53f5');                     // Use Utf8-Encode

    let obj1 = { name: "suresh", email: "sureshwa@gmail.com" }

    let json = JSON.stringify(obj)
    var encryptedCP = CryptoJS.AES.encrypt(json, key, { iv: iv });
    var decryptedWA = CryptoJS.AES.decrypt(encryptedCP, key, { iv: iv });

    var encryptedBase64 = encryptedCP.toString();                              // Short for: encryptedCP.ciphertext.toString(CryptoJS.enc.Base64);
    // var decryptedUtf8 = decryptedWA.toString(CryptoJS.enc.Utf8);               // Avoid the Base64 detour.
    // Alternatively: CryptoJS.enc.Utf8.stringify(decryptedWA);  
    // console.log("Ciphertext (Base64)  : " + encryptedBase64)
    // console.log("Ciphertext Decrypted data (Utf8): " + decryptedUtf8);
    return encryptedBase64;
}



export const redirectToPageUtil = (course, navigate, authBroker, setCourseData, dispatch, from = "course", lpId = "", lpSource = "", is_level = "false", level_id = "", isMobile = false) => {
    console.log("course", course, isMobile);
    if (isMobile) {
        let obj = { type: course.product_type, obj: course, method: "navigate-to-detail-page" }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(
                JSON.stringify(obj)
            );
        } else if (window.webkit != undefined) {
            if (
                window.webkit.messageHandlers.callbackHandler !=
                undefined
            ) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                    JSON.stringify(obj)
                );
            }
        }
        return;
    }
    if (course.isLock) {
        return;
    }
    // console.log("course 2");
    if (course?.product_type === "bundle") {
        let paramsReq = {
            lp_id: course.id,
            source: course?.origin,
            via: from
        }
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(
            `/bundleDetail?c=${encodedUrl}`
        );
    } else if (course.product_type === "service") {
        let paramsReq = {
            service_code: course?.crscd,
            service_id: course?.id
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        let url = `/coaching-detail?c=${encodedUrl}`;
        navigate(url);
    }
    else if (course?.product_type === "learningpath" || course?.entity_type === "learningpath") {
        goToLPDetailUtil(course, navigate);
    } else if (course?.product_type === "video") {
        let paramsReq = {
            code: course.crscd,
            source: course.source,
            is_paid: "false",
            lp_id: lpId,
            via_lp: "false",
            from: from,
            lp_source: lpSource,
        }
        if (level_id) {
            paramsReq.level_id = level_id;
            paramsReq.is_level = "true";
        }
        if (course?.is_home) {
            paramsReq.is_home = course.is_home;
        }



        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);

        let url = `/video-view-page/${course.id}/?c=${encodedUrl}`
        navigate(url)
    } else if (course?.product_type === "roleplay") {
        navigate(`/learn/roleplay/detail/${course?.id}`);
    } else if ((course?.source === "ecom" || course?.source === "xsel") && !course?.is_paid) {
        let paramsReq = {
            source: course?.source,
            cid: course.id ? course.id : course?.wc_post_id,
            price: course.priceInfo.price,
            is_paid: "false",
            from: from,
            lp_id: lpId,
            lp_source: lpSource,
            is_level: is_level,
            level_id: level_id,

        }
        if (course.provider_id) {
            paramsReq.provider_id = course.provider_id;
            paramsReq.provider_name = course.provider_name ? course.provider_name : "";
        }
        if (course?.is_home) {
            paramsReq.is_home = course.is_home;
        }
        if (course?.from_sub) {
            paramsReq.from_sub = course.from_sub;
        }


        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        // setCourseDetailData(course);
        // let url = `/moduleDetail/${course?.crscd}/?source=${course?.source}&cid=${course.id ? course.id : course?.wc_post_id}&price=${course.priceInfo.price}&is_paid=false`
        // url = url + `&from=${from}&lp_id=${lpId}&lp_source=${lpSource}&is_level=${is_level}&level_id=${level_id}`
        // if (level_id) {
        //     url = url + `&is_level=${is_level}&level_id=${level_id}`
        // }
        let url = `/moduleDetail/${course?.crscd}/?c=${encodedUrl}`

        navigate(url);
        // navigate(`/shopping/${course.id}/?addToCart=${course?.is_addtocart}`);
    } else if (
        course?.is_paid === "" ||
        course?.is_paid === undefined ||
        course?.is_paid
    ) {
        // console.log("course 4");
        clickStreamUser("course_card_click_goto_course", {
            courseId: course?.id,
            courseName: course?.name,
            userId: authBroker?.payload?.user.user_id,
            courseCode: course?.crscd,
        });
        if (course?.source === "broker") {
            setCourseData(course);
            // console.log("course redirect to module");
            // dispatch(
            //     getAssignBrokerCourse({
            //         module: "assignedCourseBroker",
            //         postData: {
            //             token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            //             entity_type: "courses",
            //             entity_id: course?.wc_post_id ? _.toNumber(course?.wc_post_id) : course?.id,
            //             origin: "broker",
            //             $number_of_days: "",
            //             is_type: "free",
            //         },
            //     })
            // );


            goToModuleDetail(course, navigate, from, lpId, lpSource);

        } else {
            // console.log("course redirect to assign", course);

            setCourseData(course);
            if (!course.priceInfo.isFree || !course.isLoggedIn) {
                goToModuleDetail(course, navigate, from, lpId, lpSource);
            } else {
                dispatch(
                    getAssignCourse({
                        module: "assign-course",
                        postData: {
                            user_id: authBroker?.payload?.user.user_id,
                            course_id: course?.crscd,
                        },
                    })
                );
                // dispatch(
                //     getAssignBrokerCourse({
                //         module: "assignedCourseBroker",
                //         postData: {
                //             token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                //             entity_type: "courses",
                //             entity_id: course?.crscd,
                //             origin: "xsel",
                //             number_of_days: course?.course_days,
                //             is_type: course?.is_free ? "free" : "paid",
                //             comment: course?.name,
                //         },
                //     })
                // );
            }
        }
    }
};

export const goToModuleDetail = (courseData, navigate, from = "course", lpId = "", lpSource = "", is_level = "false", level_id = "") => {

    let paramsReq = {
        source: courseData?.source,
        cid: courseData.id ? courseData.id : courseData?.wc_post_id,
        is_paid: "true",
        from: from,
        lp_id: lpId,
        lp_source: lpSource,
        is_level: is_level,
        level_id: level_id,

    }



    // let url = `/moduleDetail/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}&is_paid=true&from=${from}&lp_id=${lpId}&lp_source=${lpSource}&is_level=${is_level}&level_id=${level_id}`
    // if (isMobile) {
    //   let key = CONFIG.KEY.MOBILE_ACCESS_KEY
    //   let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    //   let userId = authBroker.payload.user.user_id
    //   let username = authBroker.payload.user.user_id
    //   let email = authBroker.payload.user.email
    //   let color1 = authBroker.payload.user.branding_primary_color_1 ?
    //     authBroker.payload.user.branding_primary_color_1 : CONFIG.COLOR_ELEMENT_1
    //   let color2 = authBroker.payload.user.branding_primary_color_2 ?
    //     authBroker.payload.user.branding_primary_color_2 : CONFIG.COLOR_ELEMENT_2
    //   url = `/courseModuleListing/${courseData?.crscd}/?source=${courseData?.source}&cid=${courseData.id ? courseData.id : courseData?.wc_post_id}`
    //   url = url + `&key=${key}&token=${token}&user_id=${userId}`
    //   url = url + `&username=${username}&webView=true&email=${email}`
    //   url = url + `&color_1=${color1}&color_2=${color2}`
    // }
    // if (courseData.course_categoryId) {
    //     url = url + `&catId=${courseData.course_categoryId}&via_cat=true`
    // } else if (courseData.isLevel) {
    //     url = url + `&lp_id=${courseData.lp_id}&via_lp=true&is_level=true&level_id=${courseData.level_id}`
    // } else if (courseData.lp_id) {
    //     url = url + `&lp_id=${courseData.lp_id}&via_lp=true`
    // }

    if (courseData.course_categoryId) {
        paramsReq.catId = courseData.course_categoryId;
        paramsReq.via_cat = "true";
    } else if (courseData.isLevel) {
        paramsReq.lp_id = courseData.lp_id;
        paramsReq.via_lp = "true";
        paramsReq.is_level = "true";
        paramsReq.level_id = courseData.level_id;
    } else if (courseData.lp_id) {
        paramsReq.lp_id = courseData.lp_id;
        paramsReq.via_lp = "true";
    }
    if (courseData.provider_id) {
        paramsReq.provider_id = courseData.provider_id;
        paramsReq.provider_name = courseData.provider_name ? courseData.provider_name : "";
    }
    if (courseData?.is_home) {
        paramsReq.is_home = courseData.is_home;
    }
    if (courseData?.from_sub) {
        paramsReq.from_sub = courseData.from_sub;
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/moduleDetail/${courseData?.crscd}/?c=${encodedUrl}`


    sessionStorage.setItem('moduleForTour', url);
    navigate(url);
}

export const navigateToView = (item) => {
    console.log("item------", item);
    let url = "";
    if (_.toLower(item?.sfdc_product_type) === "bundle") {
        let paramsReq = {
            lp_id: item?.product_id,
            source: _.lowerCase(item?.source) === "ecom" || _.lowerCase(item?.source) === "xsel" ? "xsel" : _.lowerCase(item?.source),
        }
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/bundleDetail?c=${encodedUrl}`;

    } else if (item?.product_type === "videos") {
        let paramsReq = {
            code: item?.course_code,
            source: _.lowerCase(item?.source) === "ecom" || _.lowerCase(item?.source) === "xsel" ? "xsel" : _.lowerCase(item?.source),
            is_paid: item?.priceInfo.isFree,
        }
        if (!_.isEmpty(item.categoryId)) {
            paramsReq.catId = item?.categoryId[0];
        }
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/video-view-page/${item?.product_id}/?c=${encodedUrl}`;
    } else if (item?.product_type === "service") {
        let paramsReq = {
            service_code: item?.service_code,
            service_id: item?.product_id
        };
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/coaching-detail?c=${encodedUrl}`;

    } else if (item?.product_type === "learningpath") {
        let paramsReq = {
            lp_id: item?.is_cart ? item?.post_id : item?.product_id,
            is_level: "false",
            source: _.lowerCase(item?.source) === "ecom" || _.lowerCase(item?.source) === "xsel" ? "xsel" : _.lowerCase(item?.source),
        }

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/lpDetail?c=${encodedUrl}`

    } else if (item?.product_type === "certificate") {
        let paramsReq = {
            event_id: item?.eventId,
            event_code: item?.event_code,
            fromCert: "true",
            source: _.lowerCase(item?.source) === "ecom" || _.lowerCase(item?.source) === "xsel" ? "xsel" : _.lowerCase(item?.source),
        }

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/event-detail?c=${encodedUrl}`

    }

    else if (item?.product_type === "course") {
        let paramsReq = {
            source: _.lowerCase(item?.source) === "ecom" || _.lowerCase(item?.source) === "xsel" ? "xsel" : _.lowerCase(item?.source),
            cid: item.product_id,
            is_paid: "true",

        }
        if (item?.course_categoryId) {
            paramsReq.catId = item?.course_categoryId;
            paramsReq.via_cat = "true";
        } else if (item?.isLevel) {
            paramsReq.lp_id = item?.lp_id;
            paramsReq.via_lp = "true";
            paramsReq.is_level = "true";
            paramsReq.level_id = item?.level_id;
        } else if (item?.lp_id) {
            paramsReq.lp_id = item?.lp_id;
            paramsReq.via_lp = "true";
        }


        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);

        url = `/moduleDetail/${item?.course_code}/?c=${encodedUrl}`;
    } else if (item?.product_type === "session") {
        let paramsReq = {
            event_id: item.eventId,
            event_code: item.event_code,
            source: "ecom"
        }
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        url = `/event-detail?c=${encodedUrl}`
    } else if (item?.product_type === "roleplay") {
        url = `/learn/roleplay/detail/${item?.product_id}`;
    }
    return url;
}

export const formatCartProductData = (cartData) => {
    console.log("cart-data", cartData)
    let tags = [];
    let logoURL = ""
    let btnTitle = "";
    let logoAltText = "";
    if (!_.isEmpty(cartData.provider)) {
        tags.push(cartData.provider.provider_display_name)
        logoURL = cartData.provider.provider_img;
    }
    if ((cartData.sfdc_product_type.toLowerCase() === 'bundle' ||
        cartData.product_type.toLowerCase() === 'learningpath')) {

        if (cartData.product_type.toLowerCase() === 'learningpath') {
            tags.push('Learning Path')
            logoAltText = "LP"
        }
        // tags.push('combo')
        if (cartData.courses_count) {
            tags.push(`${cartData.courses_count} Course${cartData.courses_count > 1 ? "s" : ""}`);
        }
        if (cartData.videos_count) {
            tags.push(`${cartData.videos_count} Video${cartData.videos_count > 1 ? "s" : ""}`);
        }
        if (cartData.level_count) {
            tags.push(`${cartData.level_count} Level${cartData.level_count > 1 ? "s" : ""}`);
        }
        if (cartData.lps_count) {
            tags.push(`${cartData.lps_count} Learning Path${cartData.lps_count > 1 ? "s" : ""}`);
        }
        if (cartData.event_count) {
            tags.push(`${cartData.event_count} Event${cartData.event_count > 1 ? 's' : ''}`)
        }
    } else {
        tags.push(cartData?.product_type === "certificate" ? "Session" : cartData?.product_type === "videos" ? "Video" : getEntityType(cartData.product_type))
        if (cartData.product_type == 'course') logoAltText = "CR"
        else if (cartData.product_type == 'videos') logoAltText = "VD"

        if (cartData.course_lessons) {
            tags.push(`${cartData.course_lessons} Module${cartData.course_lessons > 1 ? 's' : ''}`)
        }
        if (cartData.views && cartData.product_type != 'course') {
            tags.push(`${cartData.views} View${cartData.views > 1 ? 's' : ''}`)
        }
        if (cartData.lessons) {
            tags.push(`${cartData.lessons} Module${cartData.lessons > 1 ? 's' : ''}`)
        }
        if (cartData.event_count) {
            tags.push(`${cartData.event_count} Event${cartData.event_count > 1 ? 's' : ''}`)
        }

        if (cartData.delivery_mode) {
            tags.push(getSessionType(cartData.delivery_mode))
        }

        if (cartData.host_name) tags.push(cartData.host_name)
    }
    if (cartData.duration) {
        let duration = convertMinutesToHoursAndMinutes(cartData.duration)
        if (cartData.durationUnit === 'seconds') {
            duration = convertTimeFormat(cartData.duration, true);
        }
        tags.push(duration)
    }

    let priceInfo = getProcureInfo(cartData.purchase_info)
    cartData.priceInfo = priceInfo;
    return {
        id: cartData.product_id,
        title: cartData.product_name,
        logoURL: logoURL,
        logoAltText: '',
        bannerURL: cartData.product_thumbnail,
        tagsArray: tags,
        description: '',
        duration: '',
        showHeader: true,
        showProviderIcon: true,
        showPlayButton: false,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: navigateToView(cartData),
        descAction: navigateToView(cartData),
        bannerAction: navigateToView(cartData),
        cardClassName: 'cart-product-card',
        footerLineComp: "",
        isLoading: false,
        view: cartData.views,
        // price: cartData.product_sale_price,
        price: ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor),
        priceInfo: priceInfo,
        rightBtnIcon: '',
        lefttBtnIcon: "",
        isBundle: _.toLower(cartData?.sfdc_product_type) === "bundle",
        bundles: !_.isEmpty(cartData.course_list) ?
            _.map(cartData.course_list, entity => {
                return { thumbnail: entity.imageURL }
            }) : [],
        productType: cartData?.product_type,
        crscd: cartData?.course_code,
        source: cartData?.source,
        isMobile: cartData?.isMobile,
        service_code: cartData?.product_type === "service" ? cartData?.service_code : "",
        eventId: cartData?.product_type === "certificate" ? cartData?.eventId : "",
        eventCode: cartData?.product_type === "certificate" ? cartData?.event_code : "",
        entityId: cartData?.product_type === "learningpath" ? cartData?.product_ecom_id : ""
    }

}


export const getEntityType = (type) => {
    switch (type) {
        case "event":
            return "Event"
        case "course":
            return "Course"
        case "video":
            return "Video"
        case "level":
            return "Level"
        case "learningpath":
            return "Learning Path"
        case "bundle":
            return "Combo"
        case "roleplay":
            return "Role play"
        case "certificate":
            return "Certifications"
        case "session":
            return "Session"
        case "survey":
            return "Survey"
        default:
            return ""
            break;
    }
}

// ob_lp = 0(lp),1(my-lp),2(my-ob)
export const goToLPDetailUtil = (lpInfo, navigate, ob_lp = 0, isMobile = false) => {

    if (isMobile) {
        let obj = { type: "learningpath", obj: lpInfo, method: "navigate-to-detail-page" }
        // if(lpInfo?.product_type === "bundle") {
        //     obj.via = "lp";
        // } else {
        //     obj.ob_lp_flag = ob_lp;
        //     obj.is_level = "false";
        // }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(
                JSON.stringify(obj)
            );
        } else if (window.webkit != undefined) {
            if (
                window.webkit.messageHandlers.callbackHandler !=
                undefined
            ) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                    JSON.stringify(obj)
                );
            }
        }
        return;
    }
    if (lpInfo?.product_type === "bundle") {
        let paramsReq = {
            lp_id: lpInfo.id,
            source: lpInfo?.origin,
            via: "lp"
        }
        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(
            `/bundleDetail?c=${encodedUrl}`
        );
    } else {
        let paramsReq = {
            lp_id: lpInfo.id,
            is_level: "false",
            source: lpInfo?.origin,
            ob_lp_flag: ob_lp,
        }
        if (lpInfo.provider_id) {
            paramsReq.provider_id = lpInfo.provider_id;
            paramsReq.provider_name = lpInfo.provider_name ? lpInfo.provider_name : "";
        }
        if (lpInfo?.is_home) {
            paramsReq.is_home = true;
        }
        if (lpInfo?.fromSub) {
            paramsReq.from_sub = true;
        }

        let jsonString = JSON.stringify(paramsReq);
        let encodedUrl = btoa(jsonString);
        navigate(
            `/lpDetail?c=${encodedUrl}`
        );
    }
};


export const getTimeDiff = (start) => {
    let startTime = moment(start * 1000);
    let nowTime = moment();
    var duration = moment.duration(nowTime.diff(startTime));
    var hours = duration.asHours();
    console.log("Duration: ", hours, start)
    if (hours <= 1440) {
        return true
    } else {
        return false
    }
}



export const getFormatedDataOfLPUtils = (learning, dispatch, currentCourseName = '', setHeaderProdData = null) => {
    let sendFlag = false;
    console.log("lpDetail: ", learning);
    learning.duration = convertTimeFormat(_.toNumber(learning.duration), true);
    if (learning.coursesList) {
        learning.is_manager_checklist = false;
        let isLpInprogress = false;
        for (let [index, course] of learning.coursesList.entries()) {

            if (course.crs_progress < 100 && course.entity_type !== "survey") {
                isLpInprogress = true;
            }

            let currentCourse = course;
            let nextCourse = learning.coursesList[index + 1];
            console.log("CURRENT COURSE", currentCourse);
            console.log("NEXT COURSE", nextCourse);
            if (learning.sequence === 1) {
                console.log("is sequence");
                if (index === 0) {
                    currentCourse.isLock = false;
                }
                currentCourse.isLock =
                    currentCourse.isLock === false ? currentCourse.isLock : true;
                if (currentCourse.crs_progress > 0) {
                    console.log("CURRENT PROGRESS IS MORE THAN ZERO");
                    // currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
                    if (index !== learning.coursesList.length - 1) {
                        console.log("INDEX IS NOT LAST");
                        nextCourse.isLock =
                            _.toNumber(currentCourse.crs_progress) >= 100 &&
                                !currentCourse.isLock
                                ? false
                                : true;
                        console.log("NEXT COURSE ISLOCK", nextCourse.isLock);
                    }
                }
            } else {
                currentCourse.isLock = currentCourse.isLock
                    ? currentCourse.isLock
                    : false;
            }
            let isSecondsFlag =
                currentCourse.durationUnit != "minutes" ? true : false;
            currentCourse.duration = convertTimeFormat(
                _.toNumber(currentCourse.duration),
                isSecondsFlag
            );
            currentCourse.durationUnit = "";
            // console.log("detaiiii", course)

            // will uncomment this when checklist is available in B2C
            if (index < learning.coursesList.length - 1) {
                if (
                    !currentCourse?.is_checklist_approved &&
                    currentCourse?.is_checklist_present
                ) {
                    nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false;
                } else if (
                    currentCourse?.is_checklist_approved &&
                    currentCourse?.is_checklist_present
                ) {
                    nextCourse.isLock = false;
                }

                if (currentCourse.is_checklist_present) {
                    learning.is_manager_checklist = true;
                }
            }

            if (
                !currentCourse?.is_checklist_approved &&
                currentCourse?.is_checklist_present &&
                !sendFlag
            ) {
                if (
                    currentCourse.crs_progress >= 100 &&
                    !currentCourse.isLock &&
                    index !== learning.coursesList.length - 1
                ) {
                    dispatch(
                        getCheckListInsert({
                            module: "checklist-insert",
                            postData: {
                                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                                lp_id: learning?.id,
                                entity_id:
                                    currentCourse.source === "broker"
                                        ? currentCourse.id
                                        : currentCourse?.crscd,
                                entity_type: !currentCourse?.is_level
                                    ? currentCourse.entity_type
                                    : "level",
                            },
                        })
                    );
                    sendFlag = true;
                }
            }
        }
        for (let course of learning.coursesList) {
            course.is_manager_checklist = learning.is_manager_checklist;
        }

        // push survey to last index
        const surveyIndex = learning.coursesList.findIndex(
            (course) => course.entity_type === "survey"
        );
        if (surveyIndex !== -1) {
            const surveyCourse = learning.coursesList[surveyIndex];
            learning.coursesList.splice(surveyIndex, 1); // Remove the current index object
            learning.coursesList.push(surveyCourse); // Push it to the last index
        }

        let length = learning.coursesList.length;
        if (learning.coursesList[length - 1].entity_type === "survey" && (isLpInprogress || learning.coursesList[length - 1].status === "completed")) {
            learning.coursesList[length - 1].isLock = true;
        }

        // if (learning?.survey_optional) {
        //     learning.coursesList[length - 1].isLock = false;
        // }

        let priceInfo = getProcureInfo(learning.purchased_info);
        priceInfo.isAddToCart = learning.is_in_cart;
        console.log("PRICE INFO", priceInfo);
        let tags = [];
        let logoURL = "";
        let logoAltText = "LP";
        if (!_.isEmpty(learning.provider)) {
            tags.push(learning.provider.provider_display_name);
            logoURL = learning.provider.provider_img;
        }
        tags.push("Learning Path");
        // if (learning.provider?.provider_display_name) {
        //   tags.push(learning.provider.provider_display_name);
        // }
        // tags.push(getEntityType(learning.entity_type));

        // if (learning.entity_type === "course" && learning.lessons) {
        //   tags.push(
        //     `${learning.lessons} Module${learning.lessons > 1 ? "s" : ""}`
        //   );
        // } else if (learning.entity_type === "level") {
        // }

        if (learning.learningpath_count) {
            tags.push(
                `${learning.learningpath_count} Learning Path${learning.learningpath_count > 1 ? "s" : ""
                }`
            );
        }

        if (learning.course_count > 0)
            tags.push(
                `${learning.course_count} Course${learning.course_count > 1 ? "s" : ""
                }`
            );
        else if (learning.video_count > 0)
            tags.push(
                `${learning.video_count} Video${learning.video_count > 1 ? "s" : ""}`
            );
        else if (learning.event_count > 0)
            tags.push(
                `${learning.event_count} Event${learning.event_count > 1 ? "s" : ""}`
            );
        if (learning.duration) tags.push(learning.duration);

        // if (!isLoggedIn) priceInfo.isFree = false;
        if (setHeaderProdData !== null) {
            setHeaderProdData({
                id: learning.ecom_id,
                title: learning.prgm_nm,
                logoURL: logoURL,
                logoAltText,
                bannerURL: learning.thumbnail,
                tagsArray: tags,
                description: learning.prgm_description,
                duration: "",
                view: learning.views,
                price: priceInfo.price,
                isPaid: priceInfo.isPurchased,
                priceInfo: priceInfo,
                purchaseInfo: learning.purchased_info,
                banner: learning.banner,
            });
        }

    }

    return learning;

}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getSessionType = (type) => {
    switch (type) {
        case 'face_to_face':
            return 'In-Person'
        case 'blended_session':
            return 'In-Person / Virtual'
        case 'virtual_broadcast':
            return 'Virtual'
        case 'virtual_interactive':
            return "Virtual"
        default:
            return "Live"
    }
}

export const getFileTypeName = (file_type) => {
    switch (file_type.toLowerCase()) {
        case "mp4":
            return "Video"
        case "pdf":
            return "PDF"
        case "scorm":
            return "Self Study"
        case "url":
            return "Self Study"
        case "zip":
            return "Self Study"
        default:
            return "Self Study"
    }
}

export const encryptPassword = (password) => {
    return CryptoJS.AES.encrypt(password, CONFIG.SECRET_KEY).toString();
};

export const decryptPassword = (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, CONFIG.SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};

export const checkRankStatusFunc = (dispatch, getRankStatus) => {
    dispatch(
        getRankStatus({
            module: "getRankStatus",
            postData: {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
        })
    );
}

export const commonApiReqDel = (moduleName, dispatch, requestFunc, reqObj) => {
    dispatch(
        requestFunc({
            module: moduleName,
            postData: reqObj,
        })
    );
}




export const setFavicon = (favUrl) => {
    //  document.title = window.location.origin.includes("pwc") || window.location.origin.includes("localhost")?"PWC":"Xsel";

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = favUrl;
}

export const isMainDomain = () => {
    const domainArray = window.location.host.split('.');
    const subDomain = domainArray[0];

    if (subDomain === CONFIG.SUB_DOMAIN_NAME || subDomain.includes('localhost')) {
        return true;
    } else {
        return false;
    }
}

export const getCurrentLocationPath = (location) => {

    const domainArray = window.location.host.split('.');
    const subDomain = domainArray[0];
    localStorage.setItem(SessionKeys.LOGIN_COMPANY, subDomain)
    const locationPath = { path: location.pathname, query: location.search, company: subDomain };
    localStorage.setItem(SessionKeys.LOCATION_PATH_REDIRECT, JSON.stringify(locationPath));

    return locationPath;

}

export const getRedirectUrl = () => {
    let redirectPath = "";
        if (localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)) {
          const locationPath = JSON.parse(
            localStorage.getItem(SessionKeys.LOCATION_PATH_REDIRECT)
          );
          if (!_.isEmpty(locationPath)) {
            redirectPath = locationPath.path;
            if (locationPath.query) {
              redirectPath = redirectPath + "/" + locationPath.query;
            }
            redirectPath = btoa(redirectPath);
          }
        }
    return redirectPath;      
}